module.exports = __webpack_public_path__ + "img/red_record.6d9c8f90.png";